import { defineMessages } from "react-intl";

const messages = defineMessages({
  headingName: {
    id: "AddOn.CenterAddOnsView.headingName",
    defaultMessage: "Name",
  },
  headingType: {
    id: "AddOn.CenterAddOnsView.headingType",
    defaultMessage: "Type",
  },
  headingPrice: {
    id: "AddOn.CenterAddOnsView.headingPrice",
    defaultMessage: "Price",
  },
  headingAppliesTo: {
    id: "AddOn.CenterAddOnsView.headingAppliesTo",
    defaultMessage: "Applies to",
  },
  headingPrivate: {
    id: "AddOn.CenterAddOnsView.headingPrivate",
    defaultMessage: "Private",
  },
  privateTrue: {
    id: "AddOn.CenterAddOnsView.privateTrue",
    defaultMessage: "Yes",
  },
  privateFalse: {
    id: "AddOn.CenterAddOnsView.privateFalse",
    defaultMessage: "No",
  },
  typeStat: {
    id: "AddOn.CenterAddOnsView.typeStat",
    defaultMessage: "STAT",
  },
  typeRequiresContactingPatient: {
    id: "AddOn.CenterAddOnsView.typeRequiresContactingPatient",
    defaultMessage: "Requires Contacting Patient",
  },
  btnArchive: {
    id: "AddOn.CenterAddOnsView.btnArchive",
    defaultMessage: "Archive",
  },
  btnEdit: {
    id: "AddOn.CenterAddOnsView.btnEdit",
    defaultMessage: "Edit",
  },
});

export default messages;
